<script setup lang="ts">
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const { load: loadGoogleBusinessInformation, data: googleBusinessInformationData } = useGoogleBusinessInformation()

const stores = computed(() => {
  return props.slice.StorePages?.map((store: any) => {
    const storeData = store?.Slices?.find((s: any) => s.__typename === 'ComponentSlicesStoreData') || {}
    return {
      ...store,
      ...storeData,
      today: googleBusinessInformationData.value?.find((info: any) => info.id === storeData.GoogleBusinessInformationID)?.today?.current?.[0] || null,
    }
  }) || []
})

onMounted(() => {
  loadGoogleBusinessInformation()
})
</script>

<template>
  <StrapiSlice
    class="ct-store-locator"
    :slice="slice"
    :index="index"
  >
    <div class="ct-store-locator__list">
      <StoreLocatorTile
        v-for="store in stores"
        :key="store.UrlKey"
        class="ct-store-locator__item"
        :store="store"
      />
    </div>

    <!-- <pre>{{ slice }}</pre> -->
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/StoreLocator.css");
</style>
